module.exports = __webpack_public_path__ + "img/Webデータベースシステム入門4_6.18e80418.png";